import { getAmpConfig } from 'shared/config/amp-config';

export const injectIntercom = function () {
  return new Promise((resolve, reject) => {
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
    } else {
      const d = document;
      const i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;

      try {
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src =
          'https://widget.intercom.io/widget/' + getAmpConfig().intercomId;
        const x = d.getElementsByTagName('script')[0];
        s.addEventListener('load', () => resolve());
        s.addEventListener('error', (e) => reject(e.error));
        x?.parentNode?.insertBefore?.(s, x);
      } catch (e) {
        reject(`Failed to load intercom snippet: ${e}`);
      }
    }
  });
};
